module.exports = __webpack_public_path__ + "img/collection-engagementRingsHeart.6c3e660.jpg";